import React, { useState, useEffect } from "react";
import MaterialTable from "@material-table/core";
// import axios from "../../AxiosClient";
import axios, { jobClient } from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import JobProgress from "../components/JobProgress";
import { useInterval } from "../../utils/KpsUtils.js";
import { makeStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useHistory } from "react-router-dom";
import AuthorisationPage from "./pages/AuthorisationPage";
import Link from "@material-ui/core/Link";
import Alert from "@material-ui/lab/Alert";
import { documentLimitReached } from "../../utils/LicenceUtils";

import KnowledgeSourceDetail from "./KnowledgeSourceDetail"

// these properties are currently unused on the backend so they are
// filtered out of the settings view to avoid confusing users
const ignoreProps = [
  "tagsForKeywords",
  "titleLocation",
  "authPassword",
  "indexingState",
  "revalidation-mail-sent",
  "server.access.token",
  "server.refresh.token",
  "domain",
];

const useStyles = makeStyles((theme) => ({
  detailContainer: {
    display: "flex",
    backgroundColor: theme.palette.grey[300],
  },
  table: {
    margin: 10,
    width: "20%",
  },
  settingsTable: {
    margin: 10,
    flex: 1,
  },
  icon: {
    marginBottom: -8,
    marginRight: -4,
    marginLeft: -7,
  },
  iconSuccess: {
    color: theme.palette.success.main,
  },
  iconError: {
    color: theme.palette.error.main,
  },
  delta: {
    marginLeft: 10,
  },
}));

function ManageKnowledgeSources(props) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [ksToDelete, setKsToDelete] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [reindexSource, setReindexSource] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [settingsSearch, setSettingsSearch] = useState("");
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [clientId, setClientId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [filters, setFilters] = useState({page: 0, pageSize: 10, sort: 'sourceid', sortDirection: 'ASC', type: []})
  const tableRef = React.createRef();
  const [jobData, setJobData] = useState([])
  useEffect(
    () => {
      setColumns([
        {
          title: "id",
          field: "data.sourceId",
          hidden: true,
          defaultSort: "desc",
        },
        {
          title: t("manage_ks_description_table_header"),
          field: "data.description",
        },
        {
          title: t("global_topic"),
          field: "data.topicName",
        },
        {
          title: t("manage_ks_type_table_header"),
          field: "data.type",
          lookup: {
            EXPERT: "Expert",
            GOOGLE_DRIVE: "Google Drive",
            FILE_SHARE: "File Share",
            SHAREPOINT: "SharePoint",
            ONEDRIVE: "OneDrive",
            SALESFORCE: "Salesforce",
            WEBSITE: "Website",
            DROPBOX: "Dropbox",
          },
        },
        {
          title: t("manage_ks_url_table_header"),
          field: "data.url",
          render: (rowData) => {
            return (
              <Link
                onClick={(e) => {
                  e.stopPropagation();
                  history.push("/full/documentmanager", {
                    ksId: rowData.data.sourceId,
                  });
                }}
              >
                {rowData.data.url}
              </Link>
            );
          },
        },
        {
          title: t("manage_ks_last_indexed"),
          // type: "boolean",
          field: "data.dateReindexed",
          filtering: false,
          render: (rowData) => {
            // if (jobInProgress(rowData.data.sourceId)) {
            // if (rowData.data.isQueued || rowData.data.isBeingIndexed) {
              return <JobProgress sourceId={rowData.data.sourceId} dateIndexed={rowData.data.dateReindexed}/>;
            }
          //   if (
          //     !rowData.data.dateReindexed ||
          //     rowData.data.dateReindexed === "1970-01-01 00:00:00"
          //   ) {
          //     return <ClearIcon />;
          //   }
          //   return <DoneIcon />;
          // },
        },
        // {
        //   title: t("manage_ks_last_indexed"),
        //   field: "data.dateReindexed",
        //   type: "datetime",
        //   editable: "never",
        //   render: (rowData) => {
        //     let latestJobData = jobData.filter(j => j.sourceId === rowData.data.sourceId)
        //     let dateIndexed = latestJobData && latestJobData.dateReindexed > rowData.data.dateReindexed 
        //       ? latestJobData.dateReindexed 
        //       : rowData.data.dateReindexed 
        //     if (dateIndexed === 0) {
        //       return null;
        //     }
        //     return moment(dateIndexed).format("LLLL")
        //   },
        // },
      ]);
    },
    [t]
  );

  useInterval(() => {
    data.length > 0 &&
      getJobData()
  }, 5000);

  useEffect(
    () => {
      if (Object.keys(ksToDelete).length > 0) {
        setDeleteDialogOpen(true);
      }
    },
    [ksToDelete]
  );
  const getJobData = () => {
    // jobClient.post("/knowledgesource/data", [...data.map(d => d.id)]).then((res) => {
    //   setJobData(res.data)
    // });
  }
  const jobInProgress = (sourceId) => {
    let active = jobData.filter(j => j.status !== "NONE")
    return jobData.filter(j => j.sourceId === sourceId && j.status !== "NONE").length > 0
  }
  const getJobTriggerName = (sourceId) => {
    return jobData.filter(j => j.sourceId === sourceId)[0].jobTriggerName
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const reindexAllKnowledgeSource = (type) => {
    axios.post(`/knowledgesource/reindex?type=${type}`).then((res) => {
      enqueueSnackbar(t("manage_ks_submitted_for_reindex"), {
        variant: "success",
      });
      getJobData()
    });
  };


  const reindex = (isFullReindex, rowData) => {
    if (
      rowData.data.type === "GOOGLE_DRIVE" ||
      rowData.data.type === "" ||
      rowData.data.type === "SHAREDROPBOXPOINT" ||
      rowData.data.type === "SALESFORCE"
    ) {
      let domainAuth = rowData.data.properties.spiderProperties.authDomain;
      if (rowData.data.type === "GOOGLE_DRIVE" && domainAuth.value == "true") {
        return startReindex(isFullReindex, rowData);
      }
      setReindexSource({ ...rowData.data, isFullReindex });
      let requestType = "";
      if (rowData.data.type === "GOOGLE_DRIVE") {
        requestType = "GOOGLE_CLIENT_ID";
      } else if (rowData.data.type === "SHAREPOINT" || rowData.data.type === "ONEDRIVE") {
        requestType = "MICROSOFT_CLIENT_ID";
      } else if (rowData.data.type === "SALESFORCE") {
        requestType = "SALESFORCE_CLIENT_ID";
      } else if (rowData.data.type === "DROPBOX") {
        requestType = "DROPBOX_BUSINESS_CLIENT_ID";
      } else if (rowData.data.type === "DROPBOX") {
        requestType = "DROPBOX_USER_CLIENT_ID";
      }
      axios
        .get(`/oauthdetails/${requestType}/`, { withCredentials: true })
        .then((res) => {
          setClientId(res.data);
          setAuthDialogOpen(true);
        });
      setAuthDialogOpen(true);
    } else {
      startReindex(isFullReindex, rowData);
    }
  };

  const startReindex = (isFullReindex, rowData) => {
    axios
      .post(
        `/knowledgesource/${
          rowData.data.sourceId
        }/reindex?isFullReindex=${isFullReindex}`
      )
      .then((res) => {
        enqueueSnackbar(t("manage_ks_submitted_for_reindex"), {
          variant: "success",
        });
        // tableRef.current && tableRef.current.onQueryChange()
        getJobData()
      });
  };

  const doDelete = () => {
    setDeleteDialogOpen(false);
    axios.delete(`/knowledgesource/${ksToDelete.data.sourceId}`).then(() => {
      enqueueSnackbar(t("manage_ks_submitted_for_deletion"), {
        variant: "success",
      });
      setKsToDelete({});
    });
  };

  return (
    <div
      style={{
        overflow: "auto",
        padding: 10,
        height: "100%",
        backgroundColor: "#eae0d7",
        backgroundImage: "url('../../images/background.svg')",
      }}
    >
      {documentLimitReached() && (
        <Alert
          severity="warning"
          style={{ width: "50%", margin: "0 auto 10px auto" }}
        >
          {t("document_limit_reached_ks_reindex_warning")}
        </Alert>
      )}
      <MaterialTable
        isLoading={loading}
        columns={columns}
        tableRef={tableRef}
        data={query =>
          new Promise((resolve, reject) => {
            let newFilters = {...filters}
            newFilters.pageSize = query.pageSize
            newFilters.size = query.pageSize
            newFilters.page = query.page
            newFilters.sort = query.orderBy && query.orderBy !== null ? query.orderBy.field.replace("data.","") : null
            newFilters.sortDirection = query.orderDirection
            newFilters.search = query.search
            query.filters.forEach(f => {
              console.log(f.column.type === "datetime" ? f.value.valueOf() : f.value)
              newFilters[f.column.field.replace("data.","")] = f.column.type === "datetime" ? f.value.valueOf(): f.value
            })
            axios.post("/knowledgesource/filter", newFilters).then((res) => {
              setData(
                res.data.content.map((i) => {
                  return { id: i.sourceId, data: i };
                })
              );
              resolve({
                data: res.data.content.map((i) => {
                  return { id: i.sourceId, data: i };
                }),
                page: res.data.number,
                totalCount: res.data.totalElements,
              });
              setLoading(false);
            });

          })
        }
        // editable={{
        //   onRowUpdate: (newData, oldData) => {
        //     return new Promise((resolve) => {
        //       axios
        //         .patch(`/knowledgesource/${newData.sourceID}`, {
        //           ...newData,
        //         })
        //         .then((res) => {
        //           let newData = data.map((ele) => {
        //             if (ele.sourceID === res.data.sourceID) {
        //               return res.data;
        //             }
        //             return ele;
        //           });
        //           setData(newData);
        //           enqueueSnackbar(t("manage_ks_edited_snackbar"), {
        //             variant: "success",
        //           });
        //           resolve();
        //         });
        //     });
        //   },
        // }}
        actions={[
          {
            icon: "autorenew",
            isFreeAction: true,
            tooltip: t("manage_ks_reindex_all"),
            onClick: (e, rowData) => {
              setAnchorEl(e.currentTarget);
            },
          },
          {
            icon: "edit",
            tooltip: t("global_edit"),
            id: "edit-ks-button",
            onClick: (_e, rowData) => {
              history.push("/full/knowledgesource", {
                edit: true,
                ksId: rowData.data.sourceId,
              });
            },
          },
          {
            icon: "delete",
            tooltip: t("global_delete"),
            onClick: (_e, rowData) => {
              setKsToDelete(rowData);
            },
          },
          (rowData) => ({
            disabled: rowData.data.isQueued,
            icon: "refresh",
            tooltip: t("global_full_reindex"),
            onClick: (_e, rowData) => {
              reindex(true, rowData);
            },
          }),
          (rowData) => ({
            disabled: rowData.data.isQueued,
            icon: "rotate_right",
            tooltip: t("global_reindex"),
            onClick: (_e, rowData) => {
              reindex(false, rowData);
            },
          }),
        ]}
        detailPanel={[
          {
            render: ({ rowData }) => {
              return (
                <KnowledgeSourceDetail 
                  sourceId={rowData.data.sourceId} 
                  settingsSearch={rowData.settingsSearch}
                  sourceData={rowData.data}
                />
              );
            },
          },
        ]}
        options={{
          pageSize: 10,
          pageSizeOptions: [5, 10, 15, 20],
          filtering: true,
          headerStyle: { position: "sticky", top: 0 },
          actionsColumnIndex: -1,
        }}
        onRowClick={(_event, _rowData, togglePanel) => {
          togglePanel();
        }}
        title={t("global_knowledge_source_plural")}
      />

      <Dialog
        open={authDialogOpen}
        onClose={() => {
          setAuthDialogOpen(false);
          setReindexSource({});
        }}
        fullWidth
      >
        <DialogContent>
          {authDialogOpen && (
            <AuthorisationPage
              clientId={clientId}
              show
              isReindex
              sourceType={reindexSource.type}
              hideButtons
              knowledgeSourceId={reindexSource.sourceId}
              onAuth={() => {
                setAuthDialogOpen(false);
                setReindexSource({});
                startReindex(reindexSource.isFullReindex, {
                  data: reindexSource,
                });
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("global_are_you_sure")}
        </DialogTitle>
        <DialogContent>
          {ksToDelete.data && (
            <DialogContentText id="alert-dialog-description">
              {t("manage_ks_delete_confirm", {
                description: ksToDelete.data.description,
              })}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            color="primary"
            id="ks-delete-cancel"
          >
            {t("global_cancel")}
          </Button>
          <Button
            onClick={doDelete}
            color="primary"
            autoFocus
            id="ks-delete-confirm"
          >
            {t("global_delete")}
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disabled onClick={handleClose}>
          Reindex all sources of type...
        </MenuItem>
        <MenuItem
          value={"all"}
          onClick={() => reindexAllKnowledgeSource("all")}
        >
          All
        </MenuItem>
        <MenuItem
          value={"internal"}
          onClick={() => reindexAllKnowledgeSource("internal")}
        >
          Internal
        </MenuItem>
        <MenuItem
          value={"sharepoint"}
          onClick={() => reindexAllKnowledgeSource("sharepoint")}
        >
          SharePoint
        </MenuItem>
        <MenuItem
          value={"onedrive"}
          onClick={() => reindexAllKnowledgeSource("onedrive")}
        >
          OneDrive
        </MenuItem>
        <MenuItem
          value={"website"}
          onClick={() => reindexAllKnowledgeSource("website")}
        >
          Website
        </MenuItem>
        <MenuItem
          value={"dropbox"}
          onClick={() => reindexAllKnowledgeSource("dropbox")}
        >
          Dropbox
        </MenuItem>
        <MenuItem
          value={"GOOGLE_DRIVE"}
          onClick={() => reindexAllKnowledgeSource("GOOGLE_DRIVE")}
        >
          Google Drive
        </MenuItem>
        <MenuItem
          value={"fileshare"}
          onClick={() => reindexAllKnowledgeSource("fileshare")}
        >
          File Share
        </MenuItem>
        <MenuItem
          value={"salesforce"}
          onClick={() => reindexAllKnowledgeSource("salesforce")}
        >
          SalesForce
        </MenuItem>
        <MenuItem
          value={"expert"}
          onClick={() => reindexAllKnowledgeSource("expert")}
        >
          Expert
        </MenuItem>
      </Menu>
    </div>
  );
}

export default ManageKnowledgeSources;
